import {dateIsYYYYMMDD, reverseDateFormat} from '@/utils/dateHelper';

const showErrors = (errors = []) => {
	const errorWrapper = document.querySelector('.js-validation-errors');
	errorWrapper.innerHTML = '';

	errors.forEach((error) => {
		const item = document.createElement('li');
		const text = document.createTextNode(error);
		item.appendChild(text);
		errorWrapper.appendChild(item);
	});

	errorWrapper.scrollIntoView({behavior: 'smooth'});
};

export const handleFormSubmit = () => {
	/**
	 * @type {HTMLFormElement}
	 */
	const form = document.querySelector('form.js-form-ajax');
	let formIsSubmitting = false;

	if (!form) {
		return;
	}

	// FIXME: AJAX submit should not be necessary, add normal form post support with server side redirect to java app
	form.addEventListener('submit', (event) => {
		event.preventDefault();
		if (formIsSubmitting) {
			return;
		}
		formIsSubmitting = true;

		const formData = new FormData(form);

		// Onderstaande stuk bied de mogelijkheid om in de frontend zowel yyyy-mm-dd als dd-mm-yyyy te gebruiken.
		const birthDate = formData.get('contactInfo.birthDate');
		const deliveryAfterDate = formData.get('order.deliveryAfterDate');
		if (birthDate && dateIsYYYYMMDD(birthDate)) {
			formData.set('contactInfo.birthDate', reverseDateFormat(birthDate));
		}
		if (deliveryAfterDate && dateIsYYYYMMDD(deliveryAfterDate)) {
			formData.set('order.deliveryAfterDate', reverseDateFormat(deliveryAfterDate));
		}

		fetch(form.action, {
			method: 'POST',
			body: formData
		})
			.then((response) => {
				if (!response.ok) {
					throw Error('Response not OK');
				}
				return response.json();
			})
			.then((data) => {
				if (data.errors) {
					showErrors(data.errors);
				}

				if (data.redirectUrl) {
					document.location = data.redirectUrl;
				}
			})
			.catch((error) => {
				console.error({error});
				showErrors(['Er is iets mis gegaan bij het versturen van het formulier']);
			})
			.finally(() => {
				formIsSubmitting = false;
			});
	});
};
